import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Container = styled(Box)`
  overflow-y: auto;
`
export const Footer = styled(Box)`
  border-top: 1px solid ${({ theme }) => theme.colors.grey_4};
`
